import * as React from 'react'
import { Typography, Link } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes, RouteType } from '../../../consts'

export const AdminIndexPage = () => {
  return (
    <>
      <RouterMetaTags route={Routes.Admin} />
      <Typography variant="h2">{Routes.Admin.title}</Typography>
      <TextLink route={Routes.Admin_OutsideRequest} dot />
      <TextLink route={Routes.Admin_Outside} dot />
    </>
  )
}

export const TextLink = ({ route, dot, arrow }: { route: RouteType; dot?: boolean; arrow?: boolean }) => {
  const history = useHistory()

  return (
    <Link
      onClick={() => {
        history.push(route.path)
      }}
      display="block"
      style={{ cursor: 'pointer' }}
    >
      {arrow && '< '}
      {dot && '・'}
      {route.title}
    </Link>
  )
}
